export const LAND_IN_SAMPLE_SPACE_ONBOARDING_STATE_KEYS = {
	hasDismissedBanner: 'land-in-sample-space:hasDismissedBanner',
	hasSeenSampleContentFlag: 'land-in-sample-space:hasSeenSampleContentFlag',
} as const;

export const LandInSpampleSpaceOnboardingKeys = [
	...Object.values(LAND_IN_SAMPLE_SPACE_ONBOARDING_STATE_KEYS),
] as const;
